'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useDecisions } from '../../hooks';
import { createOrdergrooveLoaderLegacy } from './createOrdergrooveLoader.legacy';
import { createOrdergrooveLoaderV2 } from './createOrdergrooveLoader.v2';
import { getOgScriptUrl } from './utils';
type UseOrdergrooveMsiOptions = {
  onLoad: () => void;
  onError: () => void;
  isOgCookieSet: boolean;
};
export function useOrdergrooveMsi(t0) {
  const $ = _c(7);
  const {
    onLoad,
    onError,
    isOgCookieSet
  } = t0;
  const isOneTrust = useDecisions("onetrust");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getOgScriptUrl();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const scriptUrl = t1;
  let t2;
  let t3;
  if ($[1] !== isOgCookieSet || $[2] !== isOneTrust || $[3] !== onError || $[4] !== onLoad) {
    t2 = () => {
      const loaderOptions = {
        onLoad,
        onError,
        isOgCookieSet,
        scriptUrl
      };
      if (isOneTrust) {
        return createOrdergrooveLoaderV2({
          ...loaderOptions
        });
      }
      return createOrdergrooveLoaderLegacy(loaderOptions);
    };
    t3 = [isOneTrust, onLoad, onError, isOgCookieSet, scriptUrl];
    $[1] = isOgCookieSet;
    $[2] = isOneTrust;
    $[3] = onError;
    $[4] = onLoad;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
}